module.exports = __webpack_public_path__ + "img/b15.04031366.png";